<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1"> </p>
<p class="Dedication-ded"><span class="Alana-MF-Regular">For my family, especially Mike, Deb, Christine, and Dan</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2be6358f